'use client';
import type { FC } from 'react';
import React, { useCallback, useState, useEffect } from 'react';
import produce from 'immer';
import CrudItem from './crud-item';
import { ChangeType, type MoreInfo } from '../../../types';
import type { CrudDataType } from '../types';
import { uniq } from 'lodash-es';

type Props = {
  readonly: boolean;
  list: CrudDataType[];
  existList:  CrudDataType[];
  onChange: (
    list: CrudDataType[],
    moreInfo?: { index: number; payload: MoreInfo },
  ) => void;
};

const VarList: FC<Props> = ({ readonly, list, existList, onChange }) => {
  const [existCrud, setExistCrud] = useState<string[]>([]);

  //获取list内所有data的数组集合并去重
  useEffect(() => {
    const arr = existList.map((item) => item.data).flat();
    setExistCrud(uniq(arr));
  }, [list]);

  const handleVarChange = useCallback(
    (index: number) => {
      return (payload: CrudDataType, moreInfo?: MoreInfo) => {
        const newList = produce(list, (draft) => {
          draft[index] = payload;
        });
        onChange(newList, moreInfo ? { index, payload: moreInfo } : undefined);
      };
    },
    [list, onChange],
  );

  

  const handleVarRemove = useCallback(
    (index: number) => {
      return () => {
        const newList = produce(list, (draft) => {
          draft.splice(index, 1);
        });
        onChange(newList, {
          index,
          payload: {
            type: ChangeType.remove,
            payload: {
              beforeKey: list[index].id,
            },
          },
        });
      };
    },
    [list, onChange],
  );

  if (list.length === 0) {
    return (
      <div className="flex h-[42px] items-center justify-center rounded-md bg-gray-50 text-xs font-normal leading-[18px] text-gray-500">
        暂无数据
      </div>
    );
  }

  return (
    <div className="space-y-1">
      {list.map((item, index) => (
        <CrudItem
          key={index}
          readonly={readonly}
          payload={item}
          onChange={handleVarChange(index)}
          onRemove={handleVarRemove(index)}
          existCruds={existCrud}
        />
      ))}
    </div>
  );
};
export default React.memo(VarList);
